import { galleryItems } from '@/mocks/homeData';

const sizeMap: Record<string, string> = {
  landscape: 'h-52 md:h-56',
  portrait: 'h-64 md:h-72',
  squarish: 'h-52 md:h-56',
};

export default function GallerySection() {
  return (
    <section id="photos" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl">
          <p className="text-xs font-medium text-primary-700 tracking-wide flex items-center gap-2">
            <span className="w-6 h-px bg-primary-300"></span>
            图集 · 公开画面与物料
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            识别账号，先看这几张物料
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            网上流传的「吃瓜捷克照片」多为视频封面、直播切片与活动物料，真人照片极少且难核实。
            看这组图主要是帮你认风格、避仿冒，别把「封面」当成「本人自拍」。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {galleryItems.map((g) => (
            <figure
              key={g.caption}
              className="group rounded-lg overflow-hidden border border-background-200 bg-background-100"
            >
              <div className={`overflow-hidden ${sizeMap[g.w] ?? 'h-52'}`}>
                <img
                  src={g.src}
                  alt={`吃瓜捷克相关公开画面：${g.caption}`}
                  title={`吃瓜捷克 图集 ${g.caption}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <figcaption className="px-3 py-2.5 flex items-center gap-1.5 text-xs text-foreground-600 leading-snug">
                <i className="ri-image-line text-foreground-400" aria-hidden="true"></i>
                {g.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}